var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"server-errors"},[_c('p',[_vm._v(_vm._s(_vm.$t('f_server_error_message')))]),_vm._v(" "),_c('p',[_vm._v("Error: "+_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }